import React from 'react';
import { FormContainer } from '../../types/form';

export const FormContext = React.createContext<FormContainer | null>(null);
